import React from "react";
import SectionHeading from "@components/sectionHeading";
import { ContactLink } from "../components/ContactLink";

export const DeclineInProgress = () => (
  <SectionHeading
    heading="Application in progress...."
    className="margin-bottom capitalise"
    soft
    subheading={(
      <>
        Thank you for your loan application. We found that you already have an
        application with us and it is currently being looked at.<br /><br />
        If you believe that you don't have a recent active application with us, please
        contact us on <ContactLink />.
      </>
    )}
  />
);